module.exports = __webpack_public_path__ + "static/media/banner.ee4b369c.png";